import { render, staticRenderFns } from "./CaseDetails.vue?vue&type=template&id=0a37b9f0&scoped=true"
import script from "./CaseDetails.vue?vue&type=script&lang=js"
export * from "./CaseDetails.vue?vue&type=script&lang=js"
import style0 from "./CaseDetails.vue?vue&type=style&index=0&id=0a37b9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a37b9f0",
  null
  
)

export default component.exports